import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7f1ee4d3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7f1ee4d3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1ee4d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/build/dev/THIS-gfast-front-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f1ee4d3')) {
      api.createRecord('7f1ee4d3', component.options)
    } else {
      api.reload('7f1ee4d3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7f1ee4d3&scoped=true", function () {
      api.rerender('7f1ee4d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/copyrightMessage/index.vue"
export default component.exports